<!--
    SideBarModalLayout is a modal layout with a side bar on the right.
    Instead of a footer, there is a "sidebar-buttons" slot fixed at the
    bottom of the side bar.
-->
<template>
    <TmsDefaultModalLayout class="side-bar-modal-layout" :is-maximized="true" :cancel-modal="cancelModal">
        <template #header>
            <div class="sidebar-modal-header">
                <h4 class="modal-title">{{ title }}</h4>
                <h6 v-if="subtitle.length > 0" class="modal-subtitle">{{ subtitle }}</h6>
            </div>
        </template>

        <div class="body-container">
            <div class="left-content">
                <slot name="default" />
            </div>

            <div class="modal-sidebar">
                <div class="sidebar-body">
                    <slot name="sidebar" />
                </div>
                <div v-if="$slots['sidebar-buttons']" class="sidebar-buttons">
                    <slot name="sidebar-buttons" />
                </div>
            </div>
        </div>
    </TmsDefaultModalLayout>
</template>

<script>
import { defineComponent } from 'vue';

import { TmsDefaultModalLayout } from './';

export default defineComponent({
    name: 'SideBarModalLayout',
    components: { TmsDefaultModalLayout },
    props: {
        cancelModal: {
            type: Function,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: false,
            default: '',
        },
    },
});
</script>

<style lang="scss">
.side-bar-modal-layout {
    // Overrides default style on modal-body
    // TODO: Decide whether this is a style that should be in Modals.scss
    .modal-body {
        padding: 0 !important;
        overflow-x: hidden !important;
        overflow-y: hidden !important;
        max-height: none !important;
    }
}
</style>

<style lang="scss" scoped>
@import '../styles/design-language-variables';
@import './modal-variables';

$sidebar-width: 240px;

.side-bar-modal-layout {
    .sidebar-modal-header {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .body-container {
        // fit to modal-body
        max-height: 100%;
        height: 100%;

        // flex row layout
        display: flex;
        align-items: stretch;

        .left-content {
            flex-grow: 1;
        }
        .modal-sidebar {
            width: $sidebar-width;
            flex-shrink: 0;
            border-left: 1px solid $grey-mid;

            align-items: stretch;

            .sidebar-body {
                flex-grow: 1;

                display: flex;
                flex-direction: column;

                overflow-y: auto;
                overflow-x: hidden;

                padding: $modal-left-right-padding;
            }

            .sidebar-buttons {
                align-self: flex-end;
                flex-shrink: 0;

                border-top: 1px solid $grey-mid;

                width: 100%;
                padding: $modal-left-right-padding;
                min-height: $modal-min-footer-height;

                display: flex;
                align-items: center;
                gap: 8px;
            }
        }
    }
}
</style>
